import PlaceholderText from '../partials/PlaceholderText';

interface PlaceholderBlockProps {
    lines?: number;
    minCharacters?: number;
    maxCharacters?: number;
    className?: string | null;
}

function PlaceholderBlock({
    lines = 10,
    minCharacters = 20,
    maxCharacters = 40,
    className = null,
}: PlaceholderBlockProps) {
    return (
        <div className={className || undefined}>
            <p>
                <PlaceholderText
                    lines={lines}
                    minCharacters={minCharacters}
                    maxCharacters={maxCharacters}
                />
            </p>
        </div>
    );
}

export default PlaceholderBlock;
